import getConfig from 'next/config';
import React, { ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';

import { EditIcon, SignOutAccountIcon, SignOutIcon } from 'components/Icons';
import { useAuth } from 'contexts/AuthContext';
import { IUser } from 'utils/token';

import UserAvatar from '../UserAvatar/UserAvatar';

import s from './UserDropdown.module.scss';

const {
  publicRuntimeConfig: { appVersion, changePasswordUrl },
} = getConfig();

interface IProps {
  user: IUser;
}

const CustomToggle = React.forwardRef<
  HTMLDivElement,
  { children: ReactNode; onClick: (e: React.MouseEvent) => void }
>(({ children, onClick }, ref) => (
  <div
    role="presentation"
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </div>
));

CustomToggle.displayName = 'CustomToggle';

const UserDropdown: React.FC<IProps> = ({ user }) => {
  const {
    actions: { logout },
  } = useAuth();

  return (
    <Dropdown className={s.root}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-user">
        <UserAvatar user={user} />
      </Dropdown.Toggle>

      <Dropdown.Menu className={s.dropdownMenu}>
        <Dropdown.ItemText className={s.item}>
          <div className="d-flex justify-content-between align-items-center">
            <UserAvatar user={user} />
            <span className="ml-2 font-weight-bold">{user.name}</span>
          </div>
        </Dropdown.ItemText>

        <Dropdown.Item className={s.item} href={changePasswordUrl}>
          <div className="d-flex justify-content-between align-items-center">
            <span>Change password</span> <EditIcon />
          </div>
        </Dropdown.Item>

        <Dropdown.Item className={s.item}>
          <div
            className="d-flex justify-content-between align-items-center"
            role="presentation"
            onClick={() => logout()}
          >
            <span>Logout Launchpad</span>
            <SignOutIcon />
          </div>
        </Dropdown.Item>

        <Dropdown.Item className={s.item}>
          <div
            className="d-flex justify-content-between align-items-center"
            role="presentation"
            onClick={() => logout(true)}
          >
            <span>Logout Account</span>
            <SignOutAccountIcon />
          </div>
        </Dropdown.Item>

        <div className={s.version}>{appVersion}</div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserDropdown;
